import React from 'react'
import PropTypes from 'prop-types'
import DatePicker from 'react-datepicker'
import moment from 'moment'
import Select from 'react-select'
import { isEqual } from 'lodash'
import { sortOpts } from '../../utils/utils'
import Form from '../ui/Form'

class AddInvcForm extends Form {

  constructor(props){
    super(props);
    this.state = {
      data: props.data,
      errors: {}
    };
  }

  saveInvc = e => {
    e.preventDefault();
    const { data } = this.state;
    if(isEqual(this.props.data, data)) {
      this.props.cancelAdd();
    }
    else {
      this.props.addInvc(data, err => {
        if (err) {
          this.setState({errors: err});
          return;
        }
        this.props.cancelAdd();
      });
    }
  }

  showRequs = e => {
    e.preventDefault();
    this.context.router.push('/sets_requ?comp_id='+this.props.order.order_comp_id);
  }

  showMyRequs = e => {
    e.preventDefault();
    this.context.router.push('/sets_requ?comp_id='+this.props.order.order_comp1_id);
  }

  render() {
    const { requs, order } = this.props;

    const { errors, data: invc } = this.state;

    var requsOpt = [];
    var myRequsOpt = [];
    for (var key in requs){
      if(requs.hasOwnProperty(key)){
        if(
          (
            requs[key].requ_active === 1
            && requs[key].requ_comp_id === order.order_comp_id
          )
          || requs[key].requ_id === invc.invc_requ_id
        ) {
          requsOpt.push({value:requs[key].requ_id,label:requs[key].requ_desc});
        }
        if(
          (
            requs[key].requ_active === 1
            && requs[key].requ_comp_id === order.order_comp1_id
          )
          || requs[key].requ_id === invc.invc_requ1_id
        ) {
          myRequsOpt.push({value:requs[key].requ_id,label:requs[key].requ_desc});
        }
      }
    }
    requsOpt.sort(sortOpts);
    myRequsOpt.sort(sortOpts);

    return (
      <tr>
        <td>
        </td>
        <td>
          <div className="form-group">
            <textarea type="text"
              className="form-control"
              value={invc.invc_text}
              cols="80"
              placeholder="Текст в счете"
              name="invc_text"
              onChange={this.updateInput}
            />
          </div>
          <button  type="button" className="btn btn-success btn-sm"
            onClick={this.saveInvc} title="Сохранить">
            <span className="glyphicon glyphicon-save"></span>
          </button>{" "}
          <button type="button" className="btn btn-default btn-sm"
            onClick={this.props.cancelAdd} title="Отменить">
            <span className="glyphicon glyphicon-remove"></span>
          </button>
          {errors.form && <div className="alert alert-danger">{errors.form}</div>}
        </td>
        <td className="form-group">
          <input type="text"
            className="form-control"
            value={invc.invc_sum}
            name="invc_sum"
            onChange={this.updateInput}
          />
        </td>
        <td className="form-group">
          <DatePicker
            className="form-control"
            showMonthDropdown
            showYearDropdown
            dropdownMode="select"
            selected={moment(invc.invc_billed)}
            onChange={e => this.updateDate(e, 'invc_billed')}
          />
        </td>
        <td className="form-group">
          <div>
            <Select
              clearable={false}
              options={myRequsOpt}
              value={invc.invc_requ1_id}
              onChange={e => this.updateSelect(e,'invc_requ1_id')}
            />
            <button className="btn btn-default" onClick={this.showMyRequs}>
              <span className="glyphicon glyphicon-cog"></span>
            </button>
            <Select
              clearable={false}
              options={requsOpt}
              value={invc.invc_requ_id}
              onChange={e => this.updateSelect(e,'invc_requ_id')}
            />
            <button className="btn btn-default" onClick={this.showRequs}>
              <span className="glyphicon glyphicon-cog"></span>
            </button>
          </div>
        </td>
        <td>
          <label style={{cursor:'pointer'}}>
            Счет{" "}
            <input type="checkbox" checked={invc.invc_inv}
              name="invc_inv" onChange={this.handleChBox} />
          </label>{" "}
          <label style={{cursor:'pointer'}}>
            Акт{" "}
            <input type="checkbox" checked={invc.invc_act}
              name="invc_act" onChange={this.handleChBox} />
          </label>{" "}
        </td>
        <td></td>
      </tr>
    );
  }
}

AddInvcForm.contextTypes = {
  router: PropTypes.object.isRequired
}

export default AddInvcForm;



// WEBPACK FOOTER //
// ./src/components/invc/AddInvcForm.js